import type { Nullable } from "@bounce/util"

import type { PNImageProps } from "../../PNImage/PNImage"

export type PartialPostAuthor = {
  href?: Nullable<string>
  name?: Nullable<string>
  image?: PNImageProps["src"]
  metadata?: Nullable<string>
}

export type FullPostAuthor = {
  href: string
  name: string
  image: PNImageProps["src"]
  metadata?: Nullable<string>
}

export const isFullPostAuthor = (author?: PartialPostAuthor): author is FullPostAuthor => {
  return !!author?.href && !!author.name && !!author.image
}
